import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loginData: [], // Store the entire API response here
  loginScreen: null,
  otp : null,
  RegisterOtp: null,
  ForgOtp : null
};

const LoginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    loginSuccess: (state, action) => {
      state.loginData = action.payload; // Store the entire API response
    },
    login_users_realtime_details: (state, action) => {
        state.loginScreen = action.payload; // Store the entire API response
    },
    loginOtp: (state, action) => {
        state.otp = action.payload; // Store the entire API response
    },
    RegisterOtp: (state, action) => {
        state.RegisterOtp = action.payload; // Store the entire API response
    },
    ForgotOtp: (state, action) => {
      state.ForgOtp = action.payload; // Store the entire API response
  },
  },
});

export const { loginSuccess , login_users_realtime_details , loginOtp , RegisterOtp , ForgotOtp } = LoginSlice.actions;
export default LoginSlice.reducer;